import React from 'react';
import { Phone } from 'lucide-react';
import { businessInfo } from '../mockData';
import { siteConfig } from '../content/siteContent';

// Mobile-only sticky call bar (plan §7). Rendered globally from App.js;
// the spacer div keeps page content clear of the fixed bar.
const StickyCallBar = () => {
  return (
    <>
      <div className="h-16 lg:hidden" aria-hidden="true"></div>
      <div className="fixed bottom-0 inset-x-0 z-50 lg:hidden bg-red-600 border-t border-red-700 shadow-[0_-2px_10px_rgba(0,0,0,0.25)]">
        <a
          href={`tel:${businessInfo.phoneTel}`}
          className="flex items-center justify-center gap-3 h-16 px-4 text-white"
          data-testid="sticky-call-bar"
        >
          <span className="w-10 h-10 bg-white/15 rounded-full flex items-center justify-center flex-shrink-0">
            <Phone size={20} />
          </span>
          <span className="text-left leading-tight">
            <span className="block font-bold text-lg">Call {businessInfo.phone}</span>
            <span className="block text-xs text-red-100">{siteConfig.hoursLine} · Mobile — we come to you</span>
          </span>
        </a>
      </div>
    </>
  );
};

export default StickyCallBar;
